<template>
  <div class="myOrder">
    <div class="top">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <el-badge :value="orderStateCounts['1']" :hidden="!orderStateCounts['1']" class="item specialBadge">
              待付款
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label">
          <el-badge :value="orderStateCounts['2']" :hidden="!orderStateCounts['2']" class="item specialBadge">
              待发货
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待收货" name="fourth">
          <span slot="label">
          <el-badge :value="orderStateCounts['3']" :hidden="!orderStateCounts['3']" class="item specialBadge">
              待收货
            </el-badge>
          </span>
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="待还款" name="fifth">
          <div class="sub-main" v-loading="loading">
            <OrderList :flag="flag" :orderList="orderList" :total="total" :page="page" @getOrderList="getOrderList" @isCancel="isCancel" @isDelete="isDelete" @isConfirm="isConfirm" @isRefund="isRefund" @handleCurrentChange="handleCurrentChange"></OrderList>
          </div>
        </el-tab-pane>-->
        <!-- <el-tab-pane label="待商家同意" name="six">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="售后中" name="seven">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="待评价" name="eigth">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="交易完成" name="ten">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="交易关闭" name="nine">
          <div class="sub-main" v-loading="loading">
            <OrderList
              :flag="flag"
              :orderList="orderList"
              :total="total"
              :page="page"
              :screenOrderLabel="screenOrderLabel"
              @getOrderList="getOrderList"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="离线订单" name="eleven">
          <div class="sub-main" v-loading="loading">
            <div class="table-box">
              <el-table
                :data="orderList"
                border
                size="small"
                stripe
                style="width: 100%">
                <el-table-column
                  label="序号"
                  type="index"
                  align="center"
                  fixed="left"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="orderId"
                  fixed="left"
                  show-overflow-tooltip
                  label="订单编号"
                  align="center"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="merchantName"
                  label="商户名称"
                  align="left"
                  show-overflow-tooltip
                  minWidth="180">
                </el-table-column>
                <el-table-column
                  prop="totalPrice"
                  align="center"
                  show-overflow-tooltip
                  label="订单总价"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="count"
                  align="center"
                  show-overflow-tooltip
                  label="商品数量"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="totalPrice"
                  align="center"
                  show-overflow-tooltip
                  label="买家信息"
                  width="180">
                  <template slot-scope="scope">
                    {{ scope.row.customerName }} - {{ scope.row.customerPhone || '/' }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="orderState"
                  align="center"
                  show-overflow-tooltip
                  label="订单状态"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="source"
                  align="center"
                  show-overflow-tooltip
                  label="订单类型"
                  width="110">
                </el-table-column>
                <el-table-column
                  prop="sourceType"
                  align="center"
                  show-overflow-tooltip
                  label="订单来源"
                  width="110">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  align="center"
                  show-overflow-tooltip
                  label="创建时间"
                  width="140">
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="offlineOrderView(scope.row)"
                      type="text"
                      size="small">
                      查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page-box" style="display: flex;justify-content:center;margin-top: 24px;">
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="total"
                :current-page.sync="page"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="待成团" name="sixth">
          <div class="sub-main" v-loading="loading">
            <OrderList :flag="flag" :orderList="orderList" :total="total" :page="page" @getOrderList="getOrderList" @isCancel="isCancel" @isDelete="isDelete" @isConfirm="isConfirm" @isRefund="isRefund" @handleCurrentChange="handleCurrentChange"></OrderList>
          </div>
        </el-tab-pane>-->
      </el-tabs>
      <div class="search">
        <div>订单筛选：</div>
        <el-select v-model="screenOrderValue" @change="screenOrder" placeholder="请选择" style="margin-right: 15px;">
          <el-option label="零售订单" :value="0"></el-option>
          <el-option label="大宗订单" :value="1"></el-option>
        </el-select>
        <el-input placeholder="商品名称/订单号" v-model="keyword" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
        </el-input>
      </div>
      <el-dialog
        class="cancelOrder"
        :visible.sync="cancelOrderShow"
        close-on-click-modal
        :before-close="handleClose1"
        width="50%"
        title="是否取消该订单"
        center
      >
        <div>
          <p>您确定要取消该订单吗？取消订单后，不能恢复。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="cancelOrder" v-throttle>确定</el-button>
          <el-button class="rightBtn" @click="handleClose1">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="cancelOrder"
        :visible.sync="deleteOrderShow"
        close-on-click-modal
        :before-close="handleClose3"
        width="50%"
        title="是否删除该订单"
        center
      >
        <div>
          <p>您确定要删除该订单吗？删除订单后，不能恢复。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="deleteOrder" v-throttle>确定</el-button>
          <el-button class="rightBtn" @click="handleClose3">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="confirm"
        :visible.sync="confirmShow"
        close-on-click-modal
        :before-close="handleClose2"
        width="50%"
        title="是否确认收货"
        center
      >
        <div>
          <p>为了保证您的售后权益，请收到商品检查无误后再确认收货</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="confirm" v-throttle>确定</el-button>
          <el-button class="rightBtn" @click="handleClose2">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="refund"
        :visible.sync="refund"
        width="50%"
        :before-close="handleClose"
        title="请选择售后商品"
        center
      >
        <div>
          <div class="mar-bot-20 fs18">
            <el-checkbox @change="changeBox" v-model="checked">全选</el-checkbox>
          </div>
          <div class="box">
            <div
              class="back cur-poi"
              :class="productIds.indexOf(item.productId)!=-1?'backActive':''"
              @click="select(item.productId)"
              v-for="(item,index) in backList"
              :key="index"
            >
              <img class="mar-bot-10" :src="item.image" alt />
              <p style="text-align: left;" class="mar-bot-10 fs14">{{item.productName}}</p>
              <div class="mar-bot-10 fs14 font-color-999">
                <span v-for="(val,inx) in item.values" :key="inx">{{val}}</span>
              </div>
              <p class="mar-bot-20 fs14 font-color-999">x{{item.number}}</p>
              <p class="fs18 font-color-FF7">¥{{item.price}}</p>
              <img class="choice" src="../../../../static/image/bianjiao2@2x.png" alt />
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="toAfterSale" v-throttle>确定</el-button>
          <el-button class="rightBtn" @click="handleClose">取消</el-button>
        </span>
      </el-dialog>
    </div>
    
    <!-- 查看离线订单 -->
     <el-dialog
      title="订单详情"
      :visible.sync="viewVisible"
      width="600px"
      append-to-body
      :close-on-click-modal="false">
      <div style="color: #999;line-height: 30px;">
        <el-row v-if="viewData">
          <el-col :span="12">
            <div><strong style="color: #666;">订单编号：</strong>{{ viewData.orderId }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">商户名称：</strong>{{ viewData.merchantName }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">订单总价：</strong>{{ viewData.totalPrice }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">商品数量：</strong>{{ viewData.count }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">买家姓名：</strong>{{ viewData.customerName }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">买家电话：</strong>{{ viewData.customerPhone || '/' }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">订单状态：</strong>{{ viewData.orderState }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">订单类型：</strong>{{ viewData.source }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">订单来源：</strong>{{ viewData.sourceType }}</div>
          </el-col>
          <el-col :span="12">
            <div><strong style="color: #666;">创建时间：</strong>{{ viewData.createTime }}</div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleViewClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "../../../api";
import { listSearchMixin } from "../../../config/mixin";
import OrderList from "../../../components/base/orderList";
import { head } from "shelljs";
import url from "postcss-url";
export default {
  mixins: [listSearchMixin],
  components: {
    OrderList
  },
  name: "myOrder",
  data() {
    return {
      orderStateCounts:{},
      orderList: [],
      page: 1,
      activeName: this.$route.query.activeName || "first",
      keyword: "",
      state: this.$route.query.state || "",
      cancelOrderShow: false,
      refund: false,
      index: null,
      cancelId: null,
      confirmId: null,
      confirmShow: false,
      deleteId: null,
      deleteOrderShow: false,
      checked: false,
      orderData: {},
      total: 0,
      backList: [],
      productIds: [],
      productData: [],
      flag: true,
      loading: false,
      screenOrderValue:null,
      screenOrderLabel:null,
      enterpriseId:null,
      viewData:{},
      viewVisible:false,
    };
  },
  mounted() {
    let platform = localStorage.getItem('platform');
    if(platform == 'b2b'){
      this.screenOrderValue = 1;
      this.screenOrderLabel = 'b2b';
    }else{
      this.screenOrderValue = 0;
      this.screenOrderLabel = 'b2c';
    }
    this.getOrderList();
  },
  methods: {
    // 获取订单未读
    getSelfCount() {
      let self = this;
      let params = {
        url:`${api.getSelfCount}?category=${this.screenOrderValue}`,
        method: "GET",
        data: {
         
        }
      };
      self.sendReq(params, res => {
        if (res.code == "200" || res.code == '') {
          res.data.orderStateCounts.map(item=>{
            this.orderStateCounts[item.state] = item.cnt
          })
          this.$forceUpdate()
        }
      });
    },
    //筛选订单
    screenOrder(val){
      if(val == 0){
        this.screenOrderLabel = 'b2c';
      }else{
        this.screenOrderLabel = 'b2b';
      };
      this.getOrderList(val);
    },
    
    // 获取订单列表
    getOrderList(value) {
      // 先获取下订单未读
      this.getSelfCount();
      // const rLoading = this.openLoading()
      let self = this;
      self.loading = true;
      if(this.state == 6){
        let messageStore = JSON.parse(localStorage.getItem('messageStore'));
        let userInfo = messageStore.userInfo;

        self.sendReq({
          url:api.getEnterpriseDetail,
          method: "POST",
          data: {
            buyerUserId:userInfo.buyerUserId
          }
        },res => {
          // enterpriseId
          if(res.code == '200'){
            self.enterpriseId = res.data.enterpriseId;
            let params = {
              url:api.getOfflineOrderList,
              method: "POST",
              headers: {
                Domain: "35a46c147db1453587e1fa277acd410f",
                userid:userInfo.buyerUserId,
                'authorization-business':'97873993134388685287972786918921'
              },
              data: {
                size:self.pageSize,
                current:self.page,
                source:"B2B商城离线订单",
                customerId:self.enterpriseId
              }
            };
            self.sendReq(params, res => {
              if (res.code == 200) {
                self.orderList = res.data.records;
                self.total = res.data.total;
                // rLoading.close()
                self.loading = false;
              } else {
                self.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
            }else{
              self.$message({
                message: res.message,
                type: "warning"
              });
            }
          });
        
        
      }else{
        // 其他状态的订单处理
        let params = {
          url:
            api.getOrderList +
            `?category=${value != undefined? value : this.screenOrderValue}&search=${self.keyword}&state=${self.state}&page=${
              self.page
            }&pageSize=5`,
          method: "GET",
          data: {}
        };
        self.sendReq(params, res => {
          if (res.code === "200") {
            self.orderList = res.data.list;
            self.total = res.data.total;
            if (self.state === "4") {
              // for (var i in self.orderList.list) {
              //   if (self.orderList.list[i].ifNotComment === 0) {
              //     console.log(self.orderList.list[i])
              //     self.orderList.list.splice(i, 1)
              //   }
              // }
              const temp = [];
              self.orderList.map(item => {
                if (item.ifNotComment === 1) {
                  temp.push(item);
                }
              });
              self.orderList = temp;
            }
            self.orderList.forEach(i => {
              let flag = false;
              i.skus.forEach(j => {
                if (j.ifAfter) {
                  flag = true;
                }
              });
              self.$set(i, "ifAfter", flag ? 1 : 0);
            });
            if (self.orderList.length) {
              this.flag = true;
            } else {
              this.flag = false;
            }
            // rLoading.close()
            self.loading = false;
          } else {
            self.$message({
              message: res.message,
              type: "warning"
            });
          }
        });
      }
      
    },
    //离线订单分页
    handleCurrentChange(val){
      this.page = val;
      this.getOrderList();
    },
    //查看离线订单详情
    offlineOrderView(row){
      let self = this;
      let messageStore = JSON.parse(localStorage.getItem('messageStore'));
      let userInfo = messageStore.userInfo;
      // ?category=${this.screenOrderValue}
      let params = {
        url:`${api.getOffLineOrderDetail}`,
        method: "POST",
        headers: {
          Domain: "35a46c147db1453587e1fa277acd410f",
          userid:userInfo.buyerUserId,
          'authorization-business':'97873993134388685287972786918921'
        },
        data: {
         id:row.id
        }
      };
      self.sendReq(params, res => {
        if (res.code == "200" || res.code == '') {
          this.viewData = res.data;
          this.viewVisible = true;
        }else{
          this.$message.error('获取订单详情失败，请稍后重试！');
        }
      });

    },
    //关闭查看离线订单详情
    handleViewClose(){
      this.viewVisible = false;
      this.viewData = {};
    },
    // 搜索订单
    searchOrder() {
      this.activeName = "first";
      this.state = "";
      this.page = 1;
      this.getOrderList();
    },
    // 取消订单
    cancelOrder() {
      let self = this;
      let params = {
        url: api.cancelOrder,
        method: "PUT",
        data: {
          orderId: self.cancelId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "订单取消成功",
            type: "success"
          });
          self.cancelOrderShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 删除订单
    deleteOrder() {
      let self = this;
      let params = {
        url: api.deleteOrder,
        method: "DELETE",
        data: {
          orderId: self.deleteId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "订单删除成功",
            type: "success"
          });
          self.deleteOrderShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 确认收货
    confirm() {
      let self = this;
      let params = {
        url: api.confirm,
        method: "PUT",
        data: {
          orderId: self.confirmId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.$message({
            message: "确认收货成功",
            type: "success"
          });
          self.confirmShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 打开确认收货弹窗
    isConfirm(id, { schoolService, orderCheckId }) {
      let self = this;
      //确认订单,目前需要前置确认
      if (schoolService && orderCheckId!=0) {
        //需要跳转到我的收货单页面
        this.$router.push({
          path: "/receipt",
          query: {
            checkId: orderCheckId
          }
        });
      } else {
        this.confirmId = id;
        this.confirmShow = true;
      }
    },
    // 打开删除订单弹窗
    isDelete(id) {
      this.deleteOrderShow = true;
      this.deleteId = id;
      // console.log(id)
    },
    // 切换订单列表
    handleClick(event) {
      console.log(event.index, "index");
      if (event.index === "0") {
        this.state = "";
      } else {
        // if (event.index === "7") {
        //   this.state = 4;
        // }if (event.index === "8") {
        //   this.state = 5;
        // } else if (event.index === "9") {
        //   this.state = 5;
        // } else if (event.index === "4") {
        //   this.state = 8;
        // } else if (event.index === "5") {
        //   this.state = 9;
        // } else {
          this.state = event.index;
        // }
      }
      this.keyword = "";
      this.page = 1;
      this.getOrderList();
    },
    // 打开取消订单弹窗
    isCancel(id) {
      this.cancelOrderShow = true;
      this.cancelId = id;
    },
    // 关闭退货弹窗
    handleClose() {
      this.backList = [];
      this.checked = false;
      this.productIds = [];
      this.refund = false;
    },
    // 关闭删除订单弹窗
    handleClose3() {
      this.deleteOrderShow = false;
      this.deleteId = null;
    },
    // 关闭取消订单弹窗
    handleClose1() {
      this.cancelOrderShow = false;
      this.cancelId = null;
    },
    // 关闭确认收货弹窗
    handleClose2() {
      this.confirmShow = false;
      this.confirmId = null;
    },
    // 打开退货弹窗
    isRefund(data) {
      let temp = [];
      data.skus.forEach(i => {
        if (i.ifAfter) {
          temp.push(i);
        }
      });
      this.backList = temp;
      this.orderData = data;
      this.refund = true;
    },
    // 选择退货商品
    select(id) {
      if (this.productIds.indexOf(id) === -1) {
        this.productIds.push(id);
      } else {
        this.productIds.splice(this.productIds.indexOf(id), 1);
      }
      if (this.productIds.length === this.backList.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    changeBox(val) {
      if (val) {
        this.productIds = [];
        this.backList.map(item => {
          this.productIds.push(item.productId);
        });
        // console.log(this.productIds)
      } else {
        this.productIds = [];
      }
    },
    // 跳转到申请售后页面
    toAfterSale() {
      if (this.productIds.length === 0) {
        return this.$message.warning("请先选择需要申请售后的商品");
      }
      var productData = [];
      for (var k in this.productIds) {
        for (var i in this.orderData.skus) {
          if (this.orderData.skus[i].productId === this.productIds[k]) {
            productData.push(this.orderData.skus[i]);
          }
        }
      }
      var paramsData = this.orderData;
      paramsData.skus = productData;
      this.$router.push({
        path: "/afterSale",
        query: {
          orderData: JSON.stringify(paramsData),
          state: 1
        }
      });
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderList();
    }
  }
};
</script>
<style lang="scss">
.specialBadge{
    .el-badge__content{
      top: 16px !important;
    }
  }
</style>
<style lang="scss" scoped>
.myOrder {
  width: 100%;
  padding: 24px 39px;
  
  .top {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    position: relative;
    >>> .el-tabs {
      .el-tabs__header {
        border: 1px solid #e5e5e5;
        // margin-bottom: 30px;
        height: 56px;
      }
      .el-tabs__nav {
        margin-left: 20px;
        height: 56px;
      }
      .el-tabs__item {
        height: 56px;
        line-height: 56px;
      }
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
    >>> .search {
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      position: absolute;
      height: 56px;
      display: flex;
      align-items: center;
      top: 0;
      right: 0;
      .el-input {
        flex: 3;
        border-radius: 0;
        .el-input__inner {
          border-radius: 0;
        }
        .el-input-group__append {
          border-radius: 0;
          border-left: 0;
          .el-button {
            border-left: 0;
          }
        }
      }
      .el-select {
        flex: 1;
        border-radius: 0;
        height: 40px;
      }
    }
  }
  >>> .cancelOrder,
  .confirm {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      div {
        text-align: center;
        p {
          font-size: 16px;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
  >>> .refund {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      background-color: #f8f8f8;
      padding: 20px 75px;
      box-sizing: border-box;
      .box {
        display: flex;
        flex-wrap: wrap;
        overflow-x: auto;
        height: 350px;
        width: 100%;
        text-align: center;
      }
      .el-checkbox {
        display: flex;
        align-items: center;
      }
      .el-checkbox__input {
        line-height: 18px;
      }
      .el-checkbox__label {
        font-size: 18px;
      }
      .back {
        width: 208px;
        padding: 10px 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        text-align: center;
        flex-direction: column;
        background-color: #ffffff;
        margin: 0 20px 20px 0;
        border: 1px solid transparent;
        position: relative;
        img {
          width: 171px;
          height: 171px;
        }
        .choice {
          width: 30px;
          height: 30px;
          position: absolute;
          bottom: 0;
          right: 0;
          display: none;
        }
      }
      .back:nth-of-type(3n) {
        margin-right: 0;
      }
      .backActive {
        border: 1px solid #ff7800;
        .choice {
          display: block;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
}
.sub-main {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/myOrder/myOrder.vue